/* =========================================================
   MADSPEED7 — PRODUCT OPTIONS
   Select Option + Purchase Button Lock
   ========================================================= */

(function () {
  'use strict';

  var SELECT_OPTION_VALUE = '__madspeed7_select_option__';
  var SELECT_OPTION_TEXT = 'Select Option';

  var selectedValues = {};
  var initialised = false;
  var updateTimer = null;
  var variantObserver = null;
  var settling = false;
  var enforcementTimer = null;
  
  /* ---------------------------------------------------------
   Expose deliberate customer selections to Dawn product-info
   --------------------------------------------------------- */

window.MADSPEED7ProductOptions =
  window.MADSPEED7ProductOptions || {};

window.MADSPEED7ProductOptions.getSelectedValues = function () {
  return Object.assign({}, selectedValues);
};

window.MADSPEED7ProductOptions.updateFromVisibility = function () {
  updateFromVisibility();
};

  /* ---------------------------------------------------------
     Get variant selectors
     --------------------------------------------------------- */

  function getVariantSelects() {
    return document.querySelector(
      'variant-selects[data-section]'
    );
  }


  function getSelects() {
    var wrapper = getVariantSelects();

    if (!wrapper) {
      return [];
    }

    return Array.from(
      wrapper.querySelectorAll(
        '.product-form__input--dropdown select'
      )
    );
  }


  /* ---------------------------------------------------------
     Add Select Option placeholder
     --------------------------------------------------------- */

  function ensurePlaceholders() {
    var selects = getSelects();

    selects.forEach(function (select) {
      var placeholder = select.querySelector(
        'option[data-madspeed7-select-option]'
      );

      if (!placeholder) {
        placeholder = document.createElement('option');

        placeholder.value = SELECT_OPTION_VALUE;
        placeholder.textContent = SELECT_OPTION_TEXT;
        placeholder.disabled = true;

        placeholder.setAttribute(
          'data-madspeed7-select-option',
          'true'
        );

        select.insertBefore(
          placeholder,
          select.firstChild
        );
      }
    });
  }


  /* ---------------------------------------------------------
     Remember deliberate customer selections
     --------------------------------------------------------- */

  function rememberSelection(select) {
    var selects = getSelects();
    var index = selects.indexOf(select);

    if (index === -1) {
      return;
    }

    if (
      select.value &&
      select.value !== SELECT_OPTION_VALUE
    ) {
      selectedValues[index] = select.value;
    }
  }


  /* ---------------------------------------------------------
     Restore the customer's selections
     Leave later unselected options at Select Option
     --------------------------------------------------------- */

  function restoreSelections() {
    var selects = getSelects();

    selects.forEach(function (select, index) {
      var placeholder = select.querySelector(
        'option[data-madspeed7-select-option]'
      );

      if (!placeholder) {
        return;
      }

      var remembered = selectedValues[index];

      if (
        remembered &&
        select.querySelector(
          'option[value="' +
            CSS.escape(remembered) +
            '"]'
        )
      ) {
        select.value = remembered;
        placeholder.selected = false;
      } else {
        select.value = SELECT_OPTION_VALUE;
        placeholder.selected = true;
      }
    });
  }


  /* ---------------------------------------------------------
     Force untouched selectors to remain at Select Option
     while Dawn is resolving the variant
     --------------------------------------------------------- */

  function forceUnselectedToPlaceholder() {
    var selects = getSelects();

    selects.forEach(function (select, index) {
      if (selectedValues[index]) {
        return;
      }

      var placeholder = select.querySelector(
        'option[data-madspeed7-select-option]'
      );

      if (!placeholder) {
        return;
      }

      if (select.value !== SELECT_OPTION_VALUE) {
        select.value = SELECT_OPTION_VALUE;
      }

      if (!placeholder.selected) {
        placeholder.selected = true;
      }
    });
  }


  /* ---------------------------------------------------------
     Check whether every option has been deliberately selected
     --------------------------------------------------------- */

  function allOptionsSelected() {
    var selects = getSelects();

    if (!selects.length) {
      return true;
    }

    return selects.every(function (select, index) {
      return (
        selectedValues[index] &&
        select.value === selectedValues[index] &&
        select.value !== SELECT_OPTION_VALUE
      );
    });
  }

  function updateFromVisibility() {
  var fromTexts = document.querySelectorAll(
    '.product__info-container .from_text'
  );

  if (!fromTexts.length) {
    return;
  }

  var hideFrom = allOptionsSelected();

fromTexts.forEach(function (fromText) {
  fromText.style.display = hideFrom ? 'none' : '';
});
}

  function updateInventoryStatus() {
  var inventory = document.querySelector(
    '[data-ms7-inventory]'
  );

  if (!inventory) {
    return;
  }

  var status = inventory.querySelector(
    '.ms7-product-inventory__status'
  );

  var lowStock = inventory.querySelector(
    '.ms7-product-inventory__low-stock'
  );

  /*
   * When the customer has not deliberately selected
   * every option, show the general product availability.
   *
   * This also resets the status after refreshing from
   * an out-of-stock variant URL.
   */
  if (!allOptionsSelected()) {
    if (status) {
      var productAvailable =
        inventory.dataset.ms7ProductAvailable === 'true';

      status.textContent = productAvailable
        ? 'In stock'
        : 'Out of stock';

      status.classList.remove(
        'ms7-product-inventory__status--in-stock',
        'ms7-product-inventory__status--out-of-stock'
      );

      status.classList.add(
        productAvailable
          ? 'ms7-product-inventory__status--in-stock'
          : 'ms7-product-inventory__status--out-of-stock'
      );
    }

    if (lowStock) {
      lowStock.style.display = 'none';
    }

    return;
  }

  /*
   * All options have been deliberately selected.
   * Leave the selected variant's inventory status alone.
   */
  if (lowStock) {
    lowStock.style.display = '';
  }
}


  /* ---------------------------------------------------------
     Purchase controls
     --------------------------------------------------------- */

  function updatePurchaseControls() {
    var wrapper = getVariantSelects();

    if (!wrapper) {
      return;
    }

    var firstSelect = wrapper.querySelector('select');

    if (!firstSelect) {
      return;
    }

    var formId = firstSelect.getAttribute('form');

    if (!formId) {
      return;
    }

    var form = document.getElementById(formId);

    if (!form) {
      return;
    }

    var addToCartButton = form.querySelector(
      '.product-form__submit'
    );

    var shopPayButton = form.querySelector(
      '.shopify-payment-button'
    );

    var morePaymentOptions = form.querySelector(
      '.shopify-payment-button__more-options'
    );

    if (!addToCartButton) {
      return;
    }

    var enabled = allOptionsSelected();

    /* Add to Cart */
    addToCartButton.disabled = !enabled;

    addToCartButton.setAttribute(
      'aria-disabled',
      enabled ? 'false' : 'true'
    );

    addToCartButton.classList.toggle(
      'madspeed7-add-to-cart-disabled',
      !enabled
    );

    /* Shop Pay */
    if (shopPayButton) {
      shopPayButton.style.pointerEvents = enabled
        ? ''
        : 'none';

      shopPayButton.style.opacity = enabled
        ? ''
        : '0.45';
    }

    /* More payment options */
    if (morePaymentOptions) {
      morePaymentOptions.setAttribute(
        'aria-disabled',
        enabled ? 'false' : 'true'
      );

      morePaymentOptions.style.pointerEvents = enabled
        ? ''
        : 'none';

      morePaymentOptions.style.opacity = enabled
        ? ''
        : '0.45';
    }
  }


  /* ---------------------------------------------------------
     Keep later selectors hidden while Dawn resolves variant
     --------------------------------------------------------- */

  function hideUnselectedSelectors() {
    var selects = getSelects();

    selects.forEach(function (select, index) {
      if (!selectedValues[index]) {
        select.style.visibility = 'hidden';
      }
    });
  }


  function revealSelectors() {
    getSelects().forEach(function (select) {
      select.style.visibility = '';
    });
  }


  /* ---------------------------------------------------------
     Stop the temporary enforcement timer
     --------------------------------------------------------- */

  function stopEnforcement() {
    if (enforcementTimer) {
      clearInterval(enforcementTimer);
      enforcementTimer = null;
    }
  }


  /* ---------------------------------------------------------
     Start a short enforcement period.

     Dawn may update a selector more than once while resolving
     the variant. We therefore keep untouched selectors locked
     to Select Option for a short period after the customer's
     selection.

     The selectors remain hidden during this process, so the
     customer never sees an intermediate value/flicker.
     --------------------------------------------------------- */

  function startEnforcement() {
    stopEnforcement();

    forceUnselectedToPlaceholder();

    enforcementTimer = setInterval(function () {
      if (!settling) {
        stopEnforcement();
        return;
      }

      forceUnselectedToPlaceholder();
    }, 25);

    setTimeout(function () {
      stopEnforcement();
    }, 1200);
  }


  /* ---------------------------------------------------------
     Finish Dawn's variant update
     --------------------------------------------------------- */

  function finishVariantUpdate() {
    /*
     * Before revealing anything, make absolutely sure that
     * untouched selectors are still at Select Option.
     */
    forceUnselectedToPlaceholder();

    /*
     * Restore only selections that were genuinely made by
     * the customer.
     */
    restoreSelections();

    /*
     * Final safety check.
     */
    forceUnselectedToPlaceholder();

    settling = false;

updatePurchaseControls();
updateInventoryStatus();
updateFromVisibility();

revealSelectors();

    stopEnforcement();

    if (variantObserver) {
      variantObserver.disconnect();
      variantObserver = null;
    }
  }


  /* ---------------------------------------------------------
     Watch ONLY the variant selector area while Dawn updates it
     --------------------------------------------------------- */

  function watchVariantUpdate() {
    var wrapper = getVariantSelects();

    if (!wrapper) {
      return;
    }

    if (variantObserver) {
      variantObserver.disconnect();
    }

    var lastMutation = Date.now();

    variantObserver = new MutationObserver(function () {
      lastMutation = Date.now();

      /*
       * Immediately counter any automatic selection Dawn makes.
       */
      forceUnselectedToPlaceholder();

      updateFromVisibility();

      clearTimeout(updateTimer);

      updateTimer = setTimeout(function () {
        /*
         * Dawn has stopped changing the variant selector.
         * Now restore only the selections the customer
         * actually made.
         */
        if (Date.now() - lastMutation >= 80) {
          finishVariantUpdate();
        }
      }, 100);
    });

    variantObserver.observe(wrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'selected',
        'disabled'
      ]
    });

    /*
     * Safety fallback in case Dawn doesn't mutate the DOM.
     */
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      finishVariantUpdate();
    }, 700);
  }


  /* ---------------------------------------------------------
     Handle a customer changing an option
     --------------------------------------------------------- */

  function handleSelectionChange(event) {
    var target = event.target;

    if (
      !target ||
      target.tagName !== 'SELECT' ||
      !target.matches(
        'variant-selects .product-form__input--dropdown select'
      )
    ) {
      return;
    }

    /*
     * Ignore programmatic change events generated by Dawn.
     * Only a genuine customer interaction is allowed to
     * create a remembered selection.
     */
    if (!event.isTrusted) {
      return;
    }

    var selects = getSelects();
    var index = selects.indexOf(target);

    if (index === -1) {
      return;
    }

    /*
     * Record the customer's deliberate choice.
     */
    rememberSelection(target);

    /*
     * Hide selectors which have not yet been chosen.
     *
     * This prevents Dawn's automatic intermediate choice
     * from becoming visible.
     */
    hideUnselectedSelectors();

    settling = true;

    /*
     * Immediately lock all untouched selectors to Select Option.
     */
    forceUnselectedToPlaceholder();

    /*
     * Keep enforcing this while Dawn processes the variant.
     */
    startEnforcement();

    /*
     * Let Dawn process the variant change normally.
     */
    clearTimeout(updateTimer);

    watchVariantUpdate();

    /*
     * Keep the purchase controls disabled until every
     * option has been deliberately selected.
     */
    updatePurchaseControls();
  }


  /* ---------------------------------------------------------
     Initial setup
     --------------------------------------------------------- */

  function initialise() {
    var selects = getSelects();

    if (!selects.length) {
      return;
    }

    ensurePlaceholders();

    /*
     * Only create the initial Select Option state once.
     */
    if (!initialised) {
      selectedValues = {};

      selects.forEach(function (select) {
        var placeholder = select.querySelector(
          'option[data-madspeed7-select-option]'
        );

        if (placeholder) {
          select.value = SELECT_OPTION_VALUE;
          placeholder.selected = true;
        }
      });

      initialised = true;
    }

       updatePurchaseControls();
updateInventoryStatus();

    /*
     * Reset Dawn's initial variant state.
     * The dropdowns start at Select Option,
     * so the button must start as Add to cart
     * but remain disabled.
     */
    var productForm = document.querySelector('product-form');

    if (productForm) {
      productForm.toggleSubmitButton(
        true,
        window.variantStrings.addToCart
      );
    }

    /*
     * Allow Dawn to finish its initial processing,
     * then restore our initial state.
     */
    setTimeout(function () {
      ensurePlaceholders();
      forceUnselectedToPlaceholder();
      restoreSelections();
updatePurchaseControls();
updateInventoryStatus();

if (productForm) {
        productForm.toggleSubmitButton(
          true,
          window.variantStrings.addToCart
        );
      }
    }, 150);
  }


  /* ---------------------------------------------------------
     Listen for dropdown changes
     --------------------------------------------------------- */

  document.addEventListener(
    'change',
    handleSelectionChange,
    true
  );


  /* ---------------------------------------------------------
     Page initialisation
     --------------------------------------------------------- */

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initialise();
    }
  );


  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(function () {
        initialise();
      }, 100);
    }
  );


  window.addEventListener(
    'pageshow',
    function () {
      setTimeout(function () {
        initialise();
      }, 100);
    }
  );

})();